<p-dialog [(visible)]="visible" [modal]="true" [closable]="false" [draggable]="false" [resizable]="false"
  appendTo="body"
  styleClass="colaborador-form-dialog"
  [style]="isEdicao ? { width: '780px', maxWidth: '96vw' } : (perfil === 'GESTOR' ? { width: '680px', maxWidth: '96vw' } : { width: '960px', maxWidth: '96vw' })"
  [contentStyle]="{ padding: '0', maxHeight: isEdicao ? '80vh' : 'calc(88vh - 160px)', overflowY: 'auto' }">
  <ng-template pTemplate="header">
    <div class="modal-header">
      <div class="header-left">
        <div class="header-icon">
          <i [class]="isEdicao ? 'pi pi-user-edit' : (perfil === 'GESTOR' ? 'pi pi-shield' : 'pi pi-user-plus')"></i>
        </div>
        <div class="header-text">
          <span class="header-title">
            {{ isEdicao ? 'Editar Colaborador' : (perfil === 'GESTOR' ? 'Novo Gestor' : 'Novo Colaborador') }}
          </span>
          <span class="header-subtitle">
            {{ isEdicao ? 'Atualize os dados do colaborador' : (perfil === 'GESTOR' ? 'Gestor com acesso ao portal para acompanhar e gerenciar sua equipe' : 'Preencha as informações para criar um novo colaborador') }}
          </span>
        </div>
      </div>
      <button class="close-btn" type="button" (click)="onClose()">
        <i class="pi pi-times"></i>
      </button>
    </div>
  </ng-template>

  <form [formGroup]="form" (ngSubmit)="submit()">
    <div class="modal-body">

      <!-- Loading overlay enquanto dados do colaborador carregam -->
      <div *ngIf="loadingData" class="loading-overlay">
        <i class="pi pi-spin pi-spinner loading-spinner"></i>
        <span>Carregando dados...</span>
      </div>

      <!-- ═══════════════════════════════════════════════════════════════════ -->
      <!-- MODO EDIÇÃO — todos os campos de uma vez, sem stepper              -->
      <!-- ═══════════════════════════════════════════════════════════════════ -->
      <ng-container *ngIf="isEdicao">

        <!-- Foto do colaborador -->
        <div class="field-group">
          <label class="photo-label"><i class="pi pi-image"></i> Foto do colaborador <span class="opcional">(opcional)</span></label>
          <label class="avatar-block">
            <div class="avatar-preview">
              <img *ngIf="avatarPreviewUrl; else avatarIniciaisTplEdit" [appAuthSrc]="avatarPreviewUrl"
                [fallback]="'assets/avatar-placeholder.svg'" alt="Foto do colaborador" />
              <ng-template #avatarIniciaisTplEdit>
                <span class="avatar-iniciais">
                  {{ (form.get('nome')?.value || '?').charAt(0) }}{{ (form.get('sobrenome')?.value || '?').charAt(0) }}
                </span>
              </ng-template>
            </div>
            <div class="avatar-actions">
              <span class="avatar-upload-button">
                <i class="pi pi-camera"></i>
                <span>Selecionar foto</span>
              </span>
              <span class="field-hint">JPG ou PNG, até 2MB.</span>
            </div>
            <input type="file" accept="image/jpeg,image/png" (change)="onAvatarSelected($event)" hidden />
          </label>
        </div>

        <!-- Seção 1: Dados do Colaborador -->
        <div class="section-divider">
          <i class="pi pi-user"></i>
          Dados do Colaborador
        </div>

        <div class="field-row">
          <div class="field-group">
            <label for="nomeEdit"><i class="pi pi-user"></i> Nome <span style="color:#ef4444">*</span></label>
            <input pInputText id="nomeEdit" formControlName="nome" placeholder="Nome" />
            <span class="field-error" *ngIf="form.controls.nome.invalid && form.controls.nome.touched">
              Nome é obrigatório
            </span>
          </div>
          <div class="field-group">
            <label for="sobrenomeEdit">Sobrenome <span style="color:#ef4444">*</span></label>
            <input pInputText id="sobrenomeEdit" formControlName="sobrenome" placeholder="Sobrenome" />
            <span class="field-error" *ngIf="form.controls.sobrenome.invalid && form.controls.sobrenome.touched">
              Sobrenome é obrigatório
            </span>
          </div>
        </div>

        <div class="field-group">
          <label for="identificadorEdit"><i class="pi pi-id-card"></i> Identificador único <span
              style="color:#ef4444">*</span></label>
          <input pInputText id="identificadorEdit" formControlName="identificador" placeholder="Ex: COL-001" />
          <span class="field-error" *ngIf="form.controls.identificador.invalid && form.controls.identificador.touched">
            Identificador único é obrigatório
          </span>
        </div>

        <div class="field-group">
          <label for="emailEdit"><i class="pi pi-envelope"></i> E-mail corporativo <span
              style="color:#ef4444">*</span></label>
          <input pInputText id="emailEdit" formControlName="email" placeholder="colaborador@empresa.com" type="email" />
          <span class="field-error" *ngIf="form.controls.email.invalid && form.controls.email.touched">
            E-mail válido é obrigatório
          </span>
        </div>

        <!-- Seção 2: Informações na Empresa -->
        <div class="section-divider">
          <i class="pi pi-building"></i>
          Informações na Empresa
        </div>

        <div class="field-row">
          <div class="field-group">
            <label for="departamentoIdEdit"><i class="pi pi-sitemap"></i> Departamento <span
                style="color:#ef4444">*</span></label>
            <div class="field-row-with-action">
              <p-dropdown data-testid="dropdown-departamento-edit" inputId="departamentoIdEdit" formControlName="departamentoId" [options]="departamentosOptions"
                optionLabel="label" optionValue="value" placeholder="Selecione..." [showClear]="true"
                [disabled]="departamentosCarregando" [filter]="true" filterPlaceholder="Buscar..."
                emptyMessage="Não encontramos dados" emptyFilterMessage="Não encontramos dados"
                appendTo="body"></p-dropdown>
              <button type="button" class="btn-quick-create" pTooltip="Criar novo departamento" tooltipPosition="top"
                tooltipStyleClass="menu-tooltip" (click)="quickCreateDepartamento = true">
                <i class="pi pi-plus"></i>
              </button>
            </div>
            <span class="field-error"
              *ngIf="form.controls.departamentoId.invalid && form.controls.departamentoId.touched">
              Departamento é obrigatório
            </span>
          </div>
          <div class="field-group">
            <label for="cargoEdit"><i class="pi pi-briefcase"></i> Cargo <span style="color:#ef4444">*</span></label>
            <div class="field-row-with-action">
              <p-dropdown data-testid="dropdown-cargo-edit" inputId="cargoEdit" formControlName="cargo" [options]="cargosOptions" optionLabel="label"
                optionValue="value" placeholder="Selecione..." [showClear]="true" [disabled]="cargosCarregando"
                [filter]="true" filterPlaceholder="Buscar..." emptyMessage="Não encontramos dados"
                emptyFilterMessage="Não encontramos dados"
                appendTo="body"></p-dropdown>
              <button type="button" class="btn-quick-create" pTooltip="Criar novo cargo" tooltipPosition="top"
                tooltipStyleClass="menu-tooltip" (click)="quickCreateCargo = true">
                <i class="pi pi-plus"></i>
              </button>
            </div>
            <span class="field-error" *ngIf="form.controls.cargo.invalid && form.controls.cargo.touched">
              Cargo é obrigatório
            </span>
          </div>
        </div>

        <div class="field-row">
          <div class="field-group">
            <label for="gestorIdEdit"><i class="pi pi-user-edit"></i> Gestor responsável <span
                style="color:#ef4444">*</span></label>
            <p-dropdown inputId="gestorIdEdit" formControlName="gestorId" [options]="gestorOptions"
              optionLabel="nome" optionValue="idOrigem"
              placeholder="Selecione o gestor responsável"
              [filter]="true" filterPlaceholder="Buscar gestor..."
              [showClear]="true"
              [disabled]="gestoresCarregando || !form.get('departamentoId')?.value"
              emptyMessage="Não encontramos dados" emptyFilterMessage="Não encontramos dados"
              appendTo="body">
              <ng-template let-option pTemplate="item">
                <div class="gestor-option">
                  <span class="perfil-badge">Gestor</span>
                  <div class="gestor-option-info">
                    <span class="gestor-option-nome">{{ option.nome }}</span>
                    <span class="gestor-option-cargo" *ngIf="option.cargoNome">{{ option.cargoNome }}</span>
                  </div>
                </div>
              </ng-template>
            </p-dropdown>
            <span class="gestor-hint" *ngIf="gestoresCarregando">
              <i class="pi pi-spin pi-spinner"></i> Carregando gestores...
            </span>
            <span class="gestor-hint" *ngIf="!form.get('departamentoId')?.value && !gestoresCarregando">
              Selecione um departamento para habilitar este campo
            </span>
            <span class="field-error"
              *ngIf="form.controls.gestorId.invalid && form.controls.gestorId.touched && !gestoresCarregando">
              Gestor é obrigatório
            </span>
          </div>
          <div class="field-group">
            <label for="timesIdsEdit"><i class="pi pi-users"></i> Times
              <span style="color:#ef4444" *ngIf="perfil !== 'GESTOR'">*</span>
              <span class="opcional" *ngIf="perfil === 'GESTOR'">(opcional)</span>
            </label>
            <div class="field-row-with-action">
              <p-multiSelect inputId="timesIdsEdit" formControlName="timesIds" [options]="timesOptions" optionLabel="nome"
                optionValue="id" [filter]="true" emptyMessage="Não encontramos dados"
                emptyFilterMessage="Não encontramos dados" display="chip" defaultLabel="Selecione os times"
                selectedItemsLabel="{0} times selecionados"
                appendTo="body">
              </p-multiSelect>
              <button type="button" class="btn-quick-create" pTooltip="Criar novo time" tooltipPosition="top"
                tooltipStyleClass="menu-tooltip" [disabled]="!form.get('departamentoId')?.value"
                (click)="quickCreateTime = true">
                <i class="pi pi-plus"></i>
              </button>
            </div>
            <span class="gestor-hint" *ngIf="timesCarregando">
              <i class="pi pi-spin pi-spinner"></i> Carregando times...
            </span>
            <span class="gestor-hint" *ngIf="!form.get('departamentoId')?.value && !timesCarregando">
              Selecione um departamento para habilitar este campo
            </span>
            <span class="field-error"
              *ngIf="perfil !== 'GESTOR' && form.controls.timesIds.invalid && form.controls.timesIds.touched && !timesCarregando">
              Time é obrigatório
            </span>
          </div>
        </div>

        <div class="field-row field-row--single">
          <div class="field-group">
            <label for="jornadaHorasEdit"><i class="pi pi-clock"></i> Jornada diária <span
                style="color:#ef4444">*</span></label>
            <p-dropdown data-testid="dropdown-jornada-edit" inputId="jornadaHorasEdit" formControlName="jornadaHoras" [options]="jornadaOptions"
              optionLabel="label" optionValue="value" placeholder="Selecione..."
              appendTo="body"></p-dropdown>
            <span class="field-error" *ngIf="form.controls.jornadaHoras.invalid && form.controls.jornadaHoras.touched">
              Jornada é obrigatória
            </span>
          </div>
        </div>

        <!-- Seção 3: Dados Complementares -->
        <div class="section-divider">
          <i class="pi pi-id-card"></i>
          Dados Complementares
        </div>

        <div class="field-row">
          <div class="field-group">
            <label for="telefoneEdit"><i class="pi pi-phone"></i> Telefone <span class="opcional">(opcional)</span></label>
            <p-inputMask id="telefoneEdit" formControlName="telefone" mask="(99) 99999-9999" placeholder="(00) 00000-0000"
              [unmask]="false"></p-inputMask>
          </div>
          <div class="field-group">
            <label><i class="pi pi-calendar"></i> Data de contratação <span class="opcional">(opcional)</span></label>
            <p-calendar [(ngModel)]="dataContratacaoCalendar" [ngModelOptions]="{ standalone: true }" dateFormat="dd/mm/yy"
              [showIcon]="true" [showButtonBar]="true" appendTo="body" placeholder="DD/MM/AAAA"
              panelStyleClass="mini-calendar-panel" styleClass="modal-calendar" inputStyleClass="modal-calendar__input"
              (onSelect)="onDataContratacaoSelect($event)">
            </p-calendar>
          </div>
        </div>

        <div class="field-row">
          <div class="field-group">
            <label for="emailPessoalEdit"><i class="pi pi-envelope"></i> E-mail pessoal <span class="opcional">(opcional)</span></label>
            <input pInputText id="emailPessoalEdit" formControlName="emailPessoal" placeholder="pessoal@email.com"
              type="email" />
          </div>
          <div class="field-group">
            <label for="estadoCivilEdit">Estado civil <span class="opcional">(opcional)</span></label>
            <p-dropdown data-testid="dropdown-estado-civil-edit" inputId="estadoCivilEdit" formControlName="estadoCivil" [options]="estadoCivilOptions"
              optionLabel="label" optionValue="value" placeholder="Selecione..." [showClear]="true"
              appendTo="body"></p-dropdown>
          </div>
        </div>

        <div class="field-row">
          <div class="field-group">
            <label for="generoEdit">Gênero <span class="opcional">(opcional)</span></label>
            <p-dropdown data-testid="dropdown-genero-edit" inputId="generoEdit" formControlName="genero" [options]="generoOptions" optionLabel="label"
              optionValue="value" placeholder="Selecione..." [showClear]="true"
              appendTo="body"></p-dropdown>
          </div>
          <div class="field-group">
            <label><i class="pi pi-calendar"></i> Data de nascimento <span class="opcional">(opcional)</span></label>
            <p-calendar [(ngModel)]="dataNascimentoCalendar" [ngModelOptions]="{ standalone: true }" dateFormat="dd/mm/yy"
              [showIcon]="true" [maxDate]="hoje" [showButtonBar]="true" appendTo="body" placeholder="DD/MM/AAAA"
              panelStyleClass="mini-calendar-panel" styleClass="modal-calendar" inputStyleClass="modal-calendar__input"
              (onSelect)="onDataNascimentoSelect($event)">
            </p-calendar>
          </div>
        </div>

      </ng-container>

      <!-- ═══════════════════════════════════════════════════════════════════ -->
      <!-- MODO CRIAÇÃO — stepper de 3 etapas                                -->
      <!-- ═══════════════════════════════════════════════════════════════════ -->
      <ng-container *ngIf="!isEdicao">

        <!-- Stepper bar -->
        <div class="stepper">
          <div class="stepper-track">

            <!-- Step 1 -->
            <div class="step" [class.step--active]="currentStep === 1" [class.step--done]="currentStep > 1">
              <div class="step-circle">
                <i class="pi pi-check step-check" *ngIf="currentStep > 1"></i>
                <span class="step-num" *ngIf="currentStep <= 1">1</span>
              </div>
              <span class="step-label">Pessoal</span>
            </div>

            <div class="step-line" [class.step-line--done]="currentStep > 1"></div>

            <!-- Step 2 -->
            <div class="step" [class.step--active]="currentStep === 2" [class.step--done]="currentStep > 2">
              <div class="step-circle">
                <i class="pi pi-check step-check" *ngIf="currentStep > 2"></i>
                <span class="step-num" *ngIf="currentStep <= 2">2</span>
              </div>
              <span class="step-label">Empresa</span>
            </div>

            <div class="step-line" [class.step-line--done]="currentStep > 2"></div>

            <!-- Step 3 -->
            <div class="step" [class.step--active]="currentStep === 3" [class.step--done]="false">
              <div class="step-circle">
                <span class="step-num">3</span>
              </div>
              <span class="step-label">Complementar</span>
            </div>

          </div>
        </div>

        <!-- ─── Step 1: Dados Pessoais ─────────────────────────────────── -->
        <div class="step-content" [class.step-content--single]="perfil === 'GESTOR'" *ngIf="currentStep === 1">

          <!-- Foto do colaborador (só para colaborador) -->
          <div class="field-group" *ngIf="perfil !== 'GESTOR'">
            <label class="photo-label"><i class="pi pi-image"></i> Foto do colaborador <span class="opcional">(opcional)</span></label>
            <label class="avatar-block">
              <div class="avatar-preview">
                <img *ngIf="avatarPreviewUrl; else avatarIniciaisTplCreate" [appAuthSrc]="avatarPreviewUrl"
                  [fallback]="'assets/avatar-placeholder.svg'" alt="Foto do colaborador" />
                <ng-template #avatarIniciaisTplCreate>
                  <span class="avatar-iniciais">
                    {{ (form.get('nome')?.value || '?').charAt(0) }}{{ (form.get('sobrenome')?.value || '?').charAt(0) }}
                  </span>
                </ng-template>
              </div>
              <div class="avatar-actions">
                <span class="avatar-upload-button">
                  <i class="pi pi-camera"></i>
                  <span>Selecionar foto</span>
                </span>
                <span class="field-hint">JPG ou PNG, até 2MB.</span>
              </div>
              <input type="file" accept="image/jpeg,image/png" (change)="onAvatarSelected($event)" hidden />
            </label>
          </div>

          <div class="field-row" [class.field-row--single]="perfil === 'GESTOR'">
            <div class="field-group">
              <label for="nome"><i class="pi pi-user"></i> Nome <span style="color:#ef4444">*</span></label>
              <input pInputText id="nome" formControlName="nome" placeholder="Nome" />
              <span class="field-error" *ngIf="form.controls.nome.invalid && form.controls.nome.touched">
                Nome é obrigatório
              </span>
            </div>
            <div class="field-group">
              <label for="sobrenome">Sobrenome <span style="color:#ef4444">*</span></label>
              <input pInputText id="sobrenome" formControlName="sobrenome" placeholder="Sobrenome" />
              <span class="field-error" *ngIf="form.controls.sobrenome.invalid && form.controls.sobrenome.touched">
                Sobrenome é obrigatório
              </span>
            </div>
          </div>

          <div class="field-group">
            <label for="identificador"><i class="pi pi-id-card"></i> Identificador único <span
                style="color:#ef4444">*</span></label>
            <input pInputText id="identificador" formControlName="identificador" placeholder="Ex: COL-001" />
            <span class="field-error" *ngIf="form.controls.identificador.invalid && form.controls.identificador.touched">
              Identificador único é obrigatório
            </span>
          </div>

          <div class="field-group">
            <label for="email"><i class="pi pi-envelope"></i> E-mail corporativo <span
                style="color:#ef4444">*</span></label>
            <input pInputText id="email" formControlName="email" placeholder="colaborador@empresa.com" type="email" />
            <span class="field-error" *ngIf="form.controls.email.invalid && form.controls.email.touched">
              E-mail válido é obrigatório
            </span>
          </div>

        </div>

        <!-- ─── Step 2: Informações na Empresa ────────────────────────── -->
        <div class="step-content" *ngIf="currentStep === 2">

          <div class="field-row">
            <div class="field-group">
              <label for="departamentoId"><i class="pi pi-sitemap"></i> Departamento <span
                  style="color:#ef4444">*</span></label>
              <div class="field-row-with-action">
                <p-dropdown data-testid="dropdown-departamento" inputId="departamentoId" formControlName="departamentoId" [options]="departamentosOptions"
                  optionLabel="label" optionValue="value" placeholder="Selecione..." [showClear]="true"
                  [disabled]="departamentosCarregando" [filter]="true" filterPlaceholder="Buscar..."
                  emptyMessage="Não encontramos dados" emptyFilterMessage="Não encontramos dados"
                  appendTo="body"></p-dropdown>
                <button type="button" class="btn-quick-create" pTooltip="Criar novo departamento" tooltipPosition="top"
                  tooltipStyleClass="menu-tooltip" (click)="quickCreateDepartamento = true">
                  <i class="pi pi-plus"></i>
                </button>
              </div>
              <span class="field-error"
                *ngIf="form.controls.departamentoId.invalid && form.controls.departamentoId.touched">
                Departamento é obrigatório
              </span>
            </div>
            <div class="field-group">
              <label for="cargo"><i class="pi pi-briefcase"></i> Cargo <span style="color:#ef4444">*</span></label>
              <div class="field-row-with-action">
                <p-dropdown data-testid="dropdown-cargo" inputId="cargo" formControlName="cargo" [options]="cargosOptions" optionLabel="label"
                  optionValue="value" placeholder="Selecione..." [showClear]="true" [disabled]="cargosCarregando"
                  [filter]="true" filterPlaceholder="Buscar..." emptyMessage="Não encontramos dados"
                  emptyFilterMessage="Não encontramos dados"
                  appendTo="body"></p-dropdown>
                <button type="button" class="btn-quick-create" pTooltip="Criar novo cargo" tooltipPosition="top"
                  tooltipStyleClass="menu-tooltip" (click)="quickCreateCargo = true">
                  <i class="pi pi-plus"></i>
                </button>
              </div>
              <span class="field-error" *ngIf="form.controls.cargo.invalid && form.controls.cargo.touched">
                Cargo é obrigatório
              </span>
            </div>
          </div>

          <div class="field-row field-row--single">
            <div class="field-group">
              <label for="gestorId"><i class="pi pi-user-edit"></i> Gestor responsável
                <span style="color:#ef4444" *ngIf="perfil !== 'GESTOR'">*</span>
                <span class="opcional" *ngIf="perfil === 'GESTOR'">(opcional)</span>
              </label>
              <p-dropdown inputId="gestorId" formControlName="gestorId" [options]="gestorOptions"
                optionLabel="nome" optionValue="idOrigem"
                placeholder="Selecione o gestor responsável"
                [filter]="true" filterPlaceholder="Buscar gestor..."
                [showClear]="true"
                [disabled]="gestoresCarregando || !form.get('departamentoId')?.value"
                emptyMessage="Não encontramos dados" emptyFilterMessage="Não encontramos dados"
                appendTo="body">
                <ng-template let-option pTemplate="item">
                  <div class="gestor-option">
                    <span class="perfil-badge">Gestor</span>
                    <div class="gestor-option-info">
                      <span class="gestor-option-nome">{{ option.nome }}</span>
                      <span class="gestor-option-cargo" *ngIf="option.cargoNome">{{ option.cargoNome }}</span>
                    </div>
                  </div>
                </ng-template>
              </p-dropdown>
              <span class="gestor-hint" *ngIf="gestoresCarregando">
                <i class="pi pi-spin pi-spinner"></i> Carregando gestores...
              </span>
              <span class="gestor-hint" *ngIf="!form.get('departamentoId')?.value && !gestoresCarregando">
                Selecione um departamento para habilitar este campo
              </span>
              <span class="gestor-hint" *ngIf="perfil === 'GESTOR' && form.get('departamentoId')?.value && !gestoresCarregando && !form.get('gestorId')?.value">
                Se não informar, ficará no topo da cadeia hierárquica
              </span>
              <span class="field-error"
                *ngIf="perfil !== 'GESTOR' && form.controls.gestorId.invalid && form.controls.gestorId.touched && !gestoresCarregando">
                Gestor é obrigatório
              </span>
            </div>
            <div class="field-group">
              <label for="timesIds"><i class="pi pi-users"></i> Times
                <span style="color:#ef4444" *ngIf="perfil !== 'GESTOR'">*</span>
                <span class="opcional" *ngIf="perfil === 'GESTOR'">(opcional)</span>
              </label>
              <div class="field-row-with-action">
                <p-multiSelect inputId="timesIds" formControlName="timesIds" [options]="timesOptions" optionLabel="nome"
                  optionValue="id" [filter]="true" emptyMessage="Não encontramos dados"
                  emptyFilterMessage="Não encontramos dados" display="chip" defaultLabel="Selecione os times"
                  selectedItemsLabel="{0} times selecionados"
                  appendTo="body">
                </p-multiSelect>
                <button type="button" class="btn-quick-create" pTooltip="Criar novo time" tooltipPosition="top"
                  tooltipStyleClass="menu-tooltip" [disabled]="!form.get('departamentoId')?.value"
                  (click)="quickCreateTime = true">
                  <i class="pi pi-plus"></i>
                </button>
              </div>
              <span class="gestor-hint" *ngIf="timesCarregando">
                <i class="pi pi-spin pi-spinner"></i> Carregando times...
              </span>
              <span class="gestor-hint" *ngIf="!form.get('departamentoId')?.value && !timesCarregando">
                Selecione um departamento para habilitar este campo
              </span>
              <span class="field-error"
                *ngIf="perfil !== 'GESTOR' && form.controls.timesIds.invalid && form.controls.timesIds.touched && !timesCarregando">
                Time é obrigatório
              </span>
            </div>
          </div>

          <!-- BUG-015 (regressivo-pos-migracao 2026-07-29): campo "Chefe direto"
               removido do SHARED perfil=GESTOR. Mesmo racional de DEBITO-01 /
               BUG-012 nos outros 2 modais de criar gestor. Vinculo GESTOR→GESTOR
               feito depois no organograma (drag-drop / edicao). -->

          <div class="field-row field-row--single">
            <div class="field-group">
              <label for="jornadaHoras"><i class="pi pi-clock"></i> Jornada diária <span
                  style="color:#ef4444">*</span></label>
              <p-dropdown data-testid="dropdown-jornada" inputId="jornadaHoras" formControlName="jornadaHoras" [options]="jornadaOptions"
                optionLabel="label" optionValue="value" placeholder="Selecione..."
                appendTo="body"></p-dropdown>
              <span class="field-error" *ngIf="form.controls.jornadaHoras.invalid && form.controls.jornadaHoras.touched">
                Jornada é obrigatória
              </span>
            </div>
          </div>

        </div>

        <!-- ─── Step 3: Dados Complementares ─────────────────────────── -->
        <div class="step-content" *ngIf="currentStep === 3">

          <div class="field-group">
            <label for="telefone"><i class="pi pi-phone"></i> Telefone <span class="opcional">(opcional)</span></label>
            <p-inputMask id="telefone" formControlName="telefone" mask="(99) 99999-9999" placeholder="(00) 00000-0000"
              [unmask]="false"></p-inputMask>
          </div>

          <div class="field-group">
            <label for="emailPessoal"><i class="pi pi-envelope"></i> E-mail pessoal <span class="opcional">(opcional)</span></label>
            <input pInputText id="emailPessoal" formControlName="emailPessoal" placeholder="pessoal@email.com"
              type="email" />
          </div>

          <!-- Data de contratação + Data de nascimento -->
          <div class="field-row">
            <div class="field-group">
              <label><i class="pi pi-calendar"></i> Data de contratação <span class="opcional">(opcional)</span></label>
              <p-calendar [(ngModel)]="dataContratacaoCalendar" [ngModelOptions]="{ standalone: true }" dateFormat="dd/mm/yy"
                [showIcon]="true" [showButtonBar]="true" appendTo="body" placeholder="DD/MM/AAAA"
                panelStyleClass="mini-calendar-panel" styleClass="modal-calendar" inputStyleClass="modal-calendar__input"
                (onSelect)="onDataContratacaoSelect($event)">
              </p-calendar>
            </div>
            <div class="field-group">
              <label><i class="pi pi-calendar"></i> Data de nascimento <span class="opcional">(opcional)</span></label>
              <p-calendar [(ngModel)]="dataNascimentoCalendar" [ngModelOptions]="{ standalone: true }" dateFormat="dd/mm/yy"
                [showIcon]="true" [maxDate]="hoje" [showButtonBar]="true" appendTo="body" placeholder="DD/MM/AAAA"
                panelStyleClass="mini-calendar-panel" styleClass="modal-calendar" inputStyleClass="modal-calendar__input"
                (onSelect)="onDataNascimentoSelect($event)">
              </p-calendar>
            </div>
          </div>

          <!-- Estado civil + Gênero -->
          <div class="field-row">
            <div class="field-group">
              <label for="estadoCivil">Estado civil <span class="opcional">(opcional)</span></label>
              <p-dropdown data-testid="dropdown-estado-civil" inputId="estadoCivil" formControlName="estadoCivil" [options]="estadoCivilOptions"
                optionLabel="label" optionValue="value" placeholder="Selecione..." [showClear]="true"
                appendTo="body"></p-dropdown>
            </div>
            <div class="field-group">
              <label for="genero">Gênero <span class="opcional">(opcional)</span></label>
              <p-dropdown data-testid="dropdown-genero" inputId="genero" formControlName="genero" [options]="generoOptions" optionLabel="label"
                optionValue="value" placeholder="Selecione..." [showClear]="true"
                appendTo="body"></p-dropdown>
            </div>
          </div>

        </div>

      </ng-container>

    </div>
  </form>

  <ng-template pTemplate="footer">
    <!-- Footer — modo edição -->
    <div class="modal-footer" *ngIf="isEdicao">
      <button pButton type="button" label="Cancelar" class="p-button-text cancel-btn" (click)="onClose()"
        [disabled]="loading"></button>
      <button pButton type="button" label="Salvar alterações" icon="pi pi-check" class="btn-submit"
        [loading]="loading" [disabled]="form.invalid || loading || lookupCarregando"
        (click)="submit()"></button>
    </div>

    <!-- Footer — modo criação (stepper) -->
    <div class="modal-footer modal-footer--stepper" *ngIf="!isEdicao">
      <button pButton type="button" label="Cancelar" class="p-button-text cancel-btn" (click)="onClose()"
        [disabled]="loading"></button>
      <div class="stepper-nav">
        <button pButton type="button" label="Voltar" icon="pi pi-arrow-left" iconPos="left"
          class="p-button-outlined btn-voltar"
          *ngIf="currentStep > 1"
          [disabled]="loading"
          (click)="prevStep()"></button>
        <button pButton type="button" label="Próximo" icon="pi pi-arrow-right" iconPos="right"
          class="btn-submit"
          *ngIf="currentStep < totalSteps"
          [disabled]="loading || !canAdvance()"
          (click)="nextStep()"></button>
        <button pButton type="button"
          [label]="perfil === 'GESTOR' ? 'Criar Gestor' : 'Criar Colaborador'"
          [icon]="perfil === 'GESTOR' ? 'pi pi-shield' : 'pi pi-user-plus'"
          class="btn-submit"
          *ngIf="currentStep === totalSteps"
          [loading]="loading"
          [disabled]="form.invalid || loading || lookupCarregando"
          (click)="submit()"></button>
      </div>
    </div>
  </ng-template>
</p-dialog>

<!-- Quick Create — Departamento -->
<p-dialog [(visible)]="quickCreateDepartamento" [modal]="true" [closable]="false" [draggable]="false"
  [resizable]="false" [style]="{width: '480px', maxWidth: '96vw'}" [contentStyle]="{padding: '0'}"
  appendTo="body" styleClass="quick-create-dialog">
  <ng-template pTemplate="header">
    <div class="qc-header">
      <div class="qc-header-left">
        <div class="qc-icon"><i class="pi pi-building"></i></div>
        <div><span class="qc-title">Novo Departamento</span><span class="qc-sub">Cadastre um novo departamento na
            empresa</span></div>
      </div>
      <button type="button" class="qc-close" (click)="quickCreateDepartamento = false"><i
          class="pi pi-times"></i></button>
    </div>
  </ng-template>
  <div class="qc-body">
    <div class="qc-field">
      <label><i class="pi pi-building"></i> Nome do departamento</label>
      <input pInputText [(ngModel)]="novoDepartamentoNome" placeholder="Nome do departamento"
        [ngModelOptions]="{standalone: true}" />
    </div>
    <div class="qc-footer">
      <button pButton type="button" class="p-button-outlined qc-btn-cancel" label="Cancelar"
        (click)="quickCreateDepartamento = false"></button>
      <button pButton type="button" class="qc-btn-submit" label="Criar Departamento" icon="pi pi-building"
        [loading]="criandoDepartamento" [disabled]="!novoDepartamentoNome?.trim() || criandoDepartamento"
        (click)="criarDepartamentoRapido()"></button>
    </div>
  </div>
</p-dialog>

<!-- Quick Create — Cargo -->
<p-dialog [(visible)]="quickCreateCargo" [modal]="true" [closable]="false" [draggable]="false" [resizable]="false"
  [style]="{width: '480px', maxWidth: '96vw'}" [contentStyle]="{padding: '0'}"
  appendTo="body" styleClass="quick-create-dialog">
  <ng-template pTemplate="header">
    <div class="qc-header">
      <div class="qc-header-left">
        <div class="qc-icon"><i class="pi pi-briefcase"></i></div>
        <div><span class="qc-title">Novo Cargo</span><span class="qc-sub">Cadastre um novo cargo na empresa</span>
        </div>
      </div>
      <button type="button" class="qc-close" (click)="quickCreateCargo = false"><i class="pi pi-times"></i></button>
    </div>
  </ng-template>
  <div class="qc-body">
    <div class="qc-field">
      <label><i class="pi pi-briefcase"></i> Nome do cargo</label>
      <input pInputText [(ngModel)]="novoCargoNome" placeholder="Nome do cargo" [ngModelOptions]="{standalone: true}" />
    </div>
    <div class="qc-footer">
      <button pButton type="button" class="p-button-outlined qc-btn-cancel" label="Cancelar"
        (click)="quickCreateCargo = false"></button>
      <button pButton type="button" class="qc-btn-submit" label="Criar Cargo" icon="pi pi-briefcase"
        [loading]="criandoCargo" [disabled]="!novoCargoNome?.trim() || criandoCargo"
        (click)="criarCargoRapido()"></button>
    </div>
  </div>
</p-dialog>

<!-- Quick Create — Time -->
<p-dialog [(visible)]="quickCreateTime" [modal]="true" [closable]="false" [draggable]="false" [resizable]="false"
  [style]="{width: '480px', maxWidth: '96vw'}" [contentStyle]="{padding: '0'}"
  appendTo="body" styleClass="quick-create-dialog">
  <ng-template pTemplate="header">
    <div class="qc-header">
      <div class="qc-header-left">
        <div class="qc-icon"><i class="pi pi-users"></i></div>
        <div><span class="qc-title">Novo Time</span><span class="qc-sub">Organize colaboradores em um time</span>
        </div>
      </div>
      <button type="button" class="qc-close" (click)="quickCreateTime = false"><i class="pi pi-times"></i></button>
    </div>
  </ng-template>
  <div class="qc-body">
    <div class="qc-field">
      <label><i class="pi pi-users"></i> Nome do time</label>
      <input pInputText [(ngModel)]="novoTimeNome" placeholder="Nome do time" [ngModelOptions]="{standalone: true}" />
    </div>
    <div class="qc-footer">
      <button pButton type="button" class="p-button-outlined qc-btn-cancel" label="Cancelar"
        (click)="quickCreateTime = false"></button>
      <button pButton type="button" class="qc-btn-submit" label="Criar Novo Time" icon="pi pi-users"
        [loading]="criandoTime" [disabled]="!novoTimeNome?.trim() || criandoTime" (click)="criarTimeRapido()"></button>
    </div>
  </div>
</p-dialog>

<!-- BUG-017: dialog de confirmacao de transferencia de times entre gestores.
     Renderizado sempre — visibilidade controlada por transferenciaDialogVisivel.
     Reusado no SHARED via handler executarCriarGestor + onConfirmar/Cancelar. -->
<app-transferencia-times-confirm-dialog
  [visible]="transferenciaDialogVisivel"
  [conflitos]="conflitosTransferencia"
  [loading]="transferenciaLoading"
  (confirmar)="onConfirmarTransferenciaCriarGestor()"
  (cancelar)="onCancelarTransferenciaCriarGestor()">
</app-transferencia-times-confirm-dialog>